import { defineRecipe } from '@chakra-ui/react';

export const containerRecipe = defineRecipe({
    variants: {
        colorScheme: {
            primary: {
                color: '#000000',

                _hover: {

                },
            },
            variant: {
                color: 'white',

                _hover: {

                },
            },
        },
    },
});
